import React from "react";

const PageWrapper = ({ children }) => {
  return (
    <div className="relative min-h-screen">
      {/* Main Content */}
      <div className="w-full">
        {children}
      </div>
    </div>
  );
};

export default PageWrapper; 